import { atom } from 'recoil'

export const showMemberEditLayerState = atom({
	key: "showMemberEditLayerState",
	default: false
})

export const showMemberDropoutLayerState = atom({
	key: "showMemberDropoutLayerState",
	default: false
})

export const showMemberOutReasonLayerState = atom({
	key: "showMemberOutReasonLayerState",
	default: false
})

export const showMemberOutResultLayerState = atom({
	key: "showMemberOutResultLayerState",
	default: false
})

export const showMyInfoEmailState = atom({
	key: "showMyInfoEmailState",
	default: false
})

export const userLogInfoState = atom({
	key: "userLogInfoState",
	default: {}
})

export const showMyInfoNumberState = atom({
	key: "showMyInfoNumberState",
	default: false
})
//설정 - 내정보변경 - 핸드폰인증화면
export const showMyInfoNumberCertState = atom({
	key: "showMyInfoNumberCertState",
	default: false
})